/* NIMBUS // Cargo Kit — [ CARGO REVIEWS ] R-MIX (2026-10-14, brief 2026-10-14_briefing-v2-and-cargo-reviews PART B,
   mockup RX). Renders the whole reviews UI from ONE data object, so the theme and tools/review-preview.html (fixture)
   run the exact same code.

   DATA (no token anywhere — nothing secret ships):
     initial  product.metafields.judgeme.review_widget_data, trimmed in snippets/nimbus-cargo-reviews.liquid →
              <script type="application/json" data-cr-data> (count · average · histogram · photo_gallery · first page)
     more     Judge.me's public storefront widget JSON — the endpoint their own widget pages with:
              https://cdn.judge.me/reviews/reviews_for_widget?product_id=<shopify id>&page=N&per_page=10
                &sort_by=created_at&shop_domain=<myshopify domain>&platform=shopify   (CORS *, no reviewer emails)
              Merged by uuid, so the metafield page and fetched pages never double up.
   WRITE A LOG  → clicks Judge.me's own "Write a review" button inside the hidden native widget; their modal mounts
              on <body>, so submissions still go through Judge.me. Not loaded yet → waits ~6s, then reveals the widget.
   HELPFUL vote — omitted: Judge.me exposes no public vote endpoint (brief: "else omit").

   SAFETY: every reviewer-supplied string is set with textContent / attributes, never innerHTML.
   MOTION: none decorative. Row expand + popup + lightbox are instant; retro modes need no special case. */
(function () {
  'use strict';

  var ENDPOINT = 'https://cdn.judge.me/reviews/reviews_for_widget';
  var PAGE = 10;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function pad(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }
  function fmtDate(iso) {
    var d = new Date(String(iso || '').replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d)) return '----.--.--';
    return d.getUTCFullYear() + '.' + pad(d.getUTCMonth() + 1, 2) + '.' + pad(d.getUTCDate(), 2);
  }
  function ts(iso) { var t = Date.parse(String(iso || '').replace(' UTC', 'Z').replace(' ', 'T')); return isNaN(t) ? 0 : t; }
  // "Kevin J." → @kevinj · "m.rodriguezlopez" → @m.rodriguezlopez · never an email (anything after @ dropped)
  function handle(name) {
    var n = String(name || '').split('@')[0].trim();
    if (!n) return '@operator';
    var parts = n.split(/\s+/);
    var h = parts.length > 1 ? parts[0] + parts[parts.length - 1].charAt(0) : parts[0];
    h = h.toLowerCase().replace(/[^a-z0-9._-]/g, '');
    return '@' + (h || 'operator');
  }
  function initials(name) {
    var parts = String(name || '').split('@')[0].trim().split(/[\s._-]+/).filter(Boolean);
    if (!parts.length) return '··';
    return (parts[0].charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : '')).toUpperCase();
  }
  function stars(r, cls) {
    var w = el('span', 'nbp-cr-stars' + (cls ? ' ' + cls : ''));
    w.setAttribute('role', 'img');
    w.setAttribute('aria-label', r + ' out of 5 stars');
    for (var i = 1; i <= 5; i++) w.appendChild(el('span', i <= r ? 'is-on' : 'is-off', '★'));
    return w;
  }
  function pics(list) {
    return (list || []).map(function (p) {
      return { thumb: p.compact || p.small || p.original || p.huge, full: p.huge || p.original || p.compact };
    }).filter(function (p) { return p.thumb; });
  }
  function norm(r) {
    return {
      id: String(r.uuid || r.id || Math.random()),
      rating: Math.max(0, Math.min(5, parseInt(r.rating, 10) || 0)),
      title: String(r.title || '').trim(),
      body: String(r.body || (r.body_html || '').replace(/<[^>]*>/g, ' ')).replace(/\s+/g, ' ').trim(),
      created: r.created_at,
      name: r.reviewer_name || '',
      verified: !!r.verified_buyer,
      photos: pics(r.pictures_urls || r.pictures)
    };
  }

  function mount(root, data) {
    if (!root || root.__cr) return;
    root.__cr = true;
    data = data || {};
    var productId = root.getAttribute('data-product-id');
    var shop = root.getAttribute('data-shop');

    var total = parseInt(data.number_of_reviews, 10) || 0;
    var avg = parseFloat(data.average_rating) || 0;
    var hist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    (data.histogram || []).forEach(function (h) { hist[h.rating] = parseInt(h.frequency, 10) || 0; });

    var byId = {}, all = [];
    function add(list) {
      var n = 0;
      (list || []).forEach(function (raw) {
        var r = norm(raw);
        if (byId[r.id]) return;
        byId[r.id] = r; all.push(r); n++;
      });
      return n;
    }
    add(data.reviews);

    // gallery photos (metafield photo_gallery) + every loaded review's photos, unique by URL, newest first
    var photoSeen = {}, photos = [];
    function addPhotos(list, created) {
      list.forEach(function (p) {
        if (photoSeen[p.full]) return;
        photoSeen[p.full] = 1;
        photos.push({ thumb: p.thumb, full: p.full, t: ts(created) });
      });
    }
    (data.photo_gallery || []).forEach(function (g) { addPhotos(pics(g.pictures_urls), g.created_at); });
    all.forEach(function (r) { addPhotos(r.photos, r.created); });

    var state = { sort: 'newest', filter: 'all', shown: Math.min(PAGE, all.length), nextPage: 1, loading: false, done: total <= all.length };

    // ---------- shell ----------
    root.textContent = '';
    var head = el('div', 'nbp-cr-head');
    var h2 = el('h2', 'nbp-reviews-title', '[ CARGO REVIEWS ]');
    h2.id = (root.id || 'nbp-reviews') + '-title';
    root.setAttribute('aria-labelledby', h2.id);
    head.appendChild(h2);
    head.appendChild(el('span', 'nbp-cr-rule'));
    var headCount = el('span', 'nbp-reviews-count', '// COMMS CHANNEL · ' + total + ' LOGS');
    head.appendChild(headCount);
    root.appendChild(head);

    // ---------- stat strip ----------
    var statsEl = el('div', 'nbp-cr-stats');
    function tile(num, label, title) {
      var t = el('div', 'nbp-cr-stat');
      if (title) t.title = title;
      t.appendChild(el('span', 'nbp-cr-num', num));
      t.appendChild(el('span', 'nbp-cr-lbl', label));
      return t;
    }
    var pos = hist[5] + hist[4], histTotal = hist[5] + hist[4] + hist[3] + hist[2] + hist[1];
    statsEl.appendChild(tile(total ? avg.toFixed(1) : '—', '/ 5 — SIGNAL RATING'));
    statsEl.appendChild(tile(String(total), 'LOGS RECEIVED'));
    statsEl.appendChild(tile(histTotal ? Math.round(pos / histTotal * 100) + '%' : '—', 'WOULD RE-ORDER',
      'Share of logs rated 4★ or 5★ — not a survey answer'));
    var histTile = el('div', 'nbp-cr-stat nbp-cr-hist');
    histTile.setAttribute('aria-label', 'Rating distribution');
    [['5★', hist[5]], ['4★', hist[4]], ['3★', hist[3]], ['≤2', hist[2] + hist[1]]].forEach(function (row) {
      var r = el('div', 'nbp-cr-hrow');
      r.appendChild(el('span', 'nbp-cr-hk', row[0]));
      var bar = el('span', 'nbp-cr-hbar');
      var fill = el('span', 'nbp-cr-hfill');
      fill.style.width = (histTotal ? Math.round(row[1] / histTotal * 100) : 0) + '%';
      bar.appendChild(fill);
      r.appendChild(bar);
      r.appendChild(el('span', 'nbp-cr-hv', String(row[1])));
      histTile.appendChild(r);
    });
    statsEl.appendChild(histTile);
    root.appendChild(statsEl);

    // ---------- field photos strip ----------
    var stripWrap = el('div', 'nbp-cr-photos');
    stripWrap.appendChild(el('span', 'nbp-cr-sublbl', '// FIELD PHOTOS'));
    var strip = el('div', 'nbp-cr-strip');
    stripWrap.appendChild(strip);
    root.appendChild(stripWrap);
    function renderPhotos() {
      photos.sort(function (a, b) { return b.t - a.t; });
      strip.textContent = '';
      stripWrap.hidden = !photos.length;
      photos.forEach(function (p, i) {
        var b = el('button', 'nbp-cr-ph');
        b.type = 'button';
        b.setAttribute('aria-label', 'Open review photo ' + (i + 1));
        var im = el('img');
        im.src = p.thumb; im.alt = ''; im.loading = 'lazy'; im.width = 168; im.height = 126;
        b.appendChild(im);
        b.addEventListener('click', function () { openLb(photos.map(function (x) { return x.full; }), i, b); });
        strip.appendChild(b);
      });
      var up = el('button', 'nbp-cr-ph nbp-cr-upload', '+ UPLOAD');
      up.type = 'button';
      up.addEventListener('click', writeLog);
      strip.appendChild(up);
    }

    // ---------- reviews.log window ----------
    var win = el('div', 'nbp-cr-log');
    var bar = el('div', 'nbp-cr-bar');
    var tail = el('span', 'nbp-cr-tail');
    bar.appendChild(tail);
    var ctrls = el('span', 'nbp-cr-ctrls');
    function sel(label, opts, key) {
      var l = el('label', 'nbp-cr-sel');
      l.appendChild(el('span', null, label));
      var s = el('select');
      opts.forEach(function (o) { var op = el('option', null, o[1]); op.value = o[0]; s.appendChild(op); });
      s.addEventListener('change', function () { state[key] = s.value; state.shown = PAGE; render(); });
      l.appendChild(s);
      return l;
    }
    ctrls.appendChild(sel('SORT:', [['newest', 'NEWEST'], ['highest', 'HIGHEST'], ['lowest', 'LOWEST']], 'sort'));
    ctrls.appendChild(el('span', 'nbp-cr-dot', '·'));
    ctrls.appendChild(sel('FILTER:', [['all', '★ ALL'], ['5', '★ 5'], ['4', '★ 4'], ['3', '★ 3'], ['low', '★ ≤2']], 'filter'));
    bar.appendChild(ctrls);
    win.appendChild(bar);
    var list = el('ul', 'nbp-cr-rows');
    win.appendChild(list);
    var foot = el('div', 'nbp-cr-foot');
    var more = el('button', 'nbp-cr-act');
    more.type = 'button';
    more.addEventListener('click', loadMore);
    var write = el('button', 'nbp-cr-act', '> WRITE A LOG');
    write.type = 'button';
    write.addEventListener('click', writeLog);
    foot.appendChild(more);
    foot.appendChild(write);
    win.appendChild(foot);
    root.appendChild(win);

    function matches(r) {
      if (state.filter === 'all') return true;
      if (state.filter === 'low') return r.rating <= 2;
      return r.rating === parseInt(state.filter, 10);
    }
    function filterTotal() {
      if (state.filter === 'all') return total;
      if (state.filter === 'low') return hist[2] + hist[1];
      return hist[parseInt(state.filter, 10)] || 0;
    }
    function sorted() {
      var rows = all.filter(matches);
      rows.sort(function (a, b) {
        if (state.sort === 'highest') return b.rating - a.rating || ts(b.created) - ts(a.created);
        if (state.sort === 'lowest') return a.rating - b.rating || ts(b.created) - ts(a.created);
        return ts(b.created) - ts(a.created);
      });
      return rows;
    }
    // log number: chronological ordinal among the reviews loaded so far (newest = highest)
    function logNo(r) {
      var older = 0, t = ts(r.created);
      all.forEach(function (x) { if (ts(x.created) < t) older++; });
      return pad(Math.max(1, total - all.length + older + 1), 4);
    }

    function row(r) {
      var li = el('li', 'nbp-cr-row');
      li.tabIndex = 0;
      li.setAttribute('role', 'button');
      li.setAttribute('aria-label', 'Open log from ' + handle(r.name) + ', ' + r.rating + ' stars');
      li.appendChild(el('span', 'nbp-cr-date', fmtDate(r.created)));
      li.appendChild(stars(r.rating));
      var who = el('span', 'nbp-cr-who');
      who.appendChild(el('span', 'nbp-cr-handle', handle(r.name)));
      if (r.verified) who.appendChild(el('span', 'nbp-cr-ver', 'VERIFIED CARGO'));
      li.appendChild(who);
      li.appendChild(el('span', 'nbp-cr-text', (r.title ? r.title + ' — ' : '') + r.body));
      var tog = el('button', 'nbp-cr-tog');   // glyph [+] / [–] is CSS ::before — it must also flip on desktop hover
      tog.type = 'button';
      tog.setAttribute('aria-expanded', 'false');
      tog.setAttribute('aria-label', 'Expand log text');
      tog.addEventListener('click', function (e) {
        e.stopPropagation();
        var on = !li.classList.contains('is-open');
        li.classList.toggle('is-open', on);
        tog.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      li.appendChild(tog);
      li.addEventListener('click', function () { openLog(r, li); });
      li.addEventListener('keydown', function (e) {
        if (e.target !== li) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLog(r, li); }
      });
      return li;
    }

    function render() {
      var rows = sorted();
      var show = rows.slice(0, state.shown);
      list.textContent = '';
      if (!total) {
        list.appendChild(el('li', 'nbp-cr-empty', '> no logs received yet. be the first operator on record.'));
      } else if (!show.length) {
        list.appendChild(el('li', 'nbp-cr-empty', state.loading ? '> receiving…' : '> no logs on this channel yet.'));
      }
      show.forEach(function (r) { list.appendChild(row(r)); });
      tail.textContent = 'reviews.log — tail -n ' + show.length;
      var remaining = Math.max(0, filterTotal() - show.length);
      more.hidden = !total || remaining === 0 || (state.done && rows.length <= show.length);
      more.textContent = state.loading ? '> RECEIVING…' : '> LOAD MORE (' + remaining + ' remaining)';
      more.disabled = state.loading;
    }

    function fetchPage() {
      if (state.done || !productId || !shop) { state.done = true; return Promise.resolve(0); }
      var url = ENDPOINT + '?product_id=' + encodeURIComponent(productId) + '&page=' + state.nextPage + '&per_page=' + PAGE +
        '&sort_by=created_at&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify';
      return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          state.nextPage++;
          var n = add(j.reviews);
          if (n) { all.slice(-n).forEach(function (r) { addPhotos(r.photos, r.created); }); renderPhotos(); }
          var tp = j.pagination && j.pagination.total_pages;
          if (!j.reviews || !j.reviews.length || (tp && state.nextPage > tp) || all.length >= total) state.done = true;
          return n;
        })
        .catch(function () { state.done = true; return 0; });
    }
    function loadMore() {
      if (state.loading) return;
      var want = state.shown + PAGE;
      function step() {
        if (sorted().length >= want || state.done) {
          state.loading = false; state.shown = want; render(); return;
        }
        fetchPage().then(step);
      }
      state.loading = true; render(); step();
    }

    // ---------- WRITE A LOG → Judge.me's own modal ----------
    function writeLog() {
      var host = root.parentNode && root.parentNode.querySelector('[data-cr-native]');
      var tries = 0;
      (function attempt() {
        var b = document.querySelector('#judgeme_product_reviews .jm-action-buttons__button, .jdgm-write-rev-link, [data-cr-native] .jm-button--primary');
        if (b) { b.click(); return; }
        if (++tries < 30) { setTimeout(attempt, 200); return; }
        if (host) { host.hidden = false; host.scrollIntoView({ block: 'start' }); }   // script never arrived: show theirs
      })();
    }

    // ---------- overlays (reuse .nbp-pop / .nbp-lb chrome; own data attributes so the gallery + trust-chip
    //            scripts, which query [data-pop] / [data-lb*], never pick these up) ----------
    var lastFocus = null;
    function trap(container, e) {
      if (e.key !== 'Tab') return;
      var f = container.querySelectorAll('button:not([disabled]),[href],[tabindex="0"]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    var pop = el('div', 'nbp-pop nbp-cr-pop');
    pop.tabIndex = -1;
    pop.setAttribute('aria-hidden', 'true');
    var card = el('div', 'nbp-popcard nbp-cr-card is-active');
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');
    pop.appendChild(card);
    document.body.appendChild(pop);
    function closeLog() {
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    pop.addEventListener('mousedown', function (e) { if (e.target === pop) closeLog(); });
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeLog(); return; }
      trap(card, e);
    });
    function openLog(r, from) {
      lastFocus = from || document.activeElement;
      card.textContent = '';
      var hd = el('div', 'nbp-pop-head');
      var title = el('span', 'nbp-pop-title', '[ LOG · ' + logNo(r) + ' ]');
      title.id = h2.id + '-log';
      card.setAttribute('aria-labelledby', title.id);
      hd.appendChild(title);
      var x = el('button', 'nbp-pop-close', '✕');
      x.type = 'button'; x.setAttribute('aria-label', 'Close');
      x.addEventListener('click', closeLog);
      hd.appendChild(x);
      card.appendChild(hd);
      var id = el('div', 'nbp-cr-id');
      id.appendChild(el('span', 'nbp-cr-avatar', initials(r.name)));
      var meta = el('div', 'nbp-cr-idmeta');
      meta.appendChild(el('span', 'nbp-cr-handle', handle(r.name)));
      meta.appendChild(el('span', 'nbp-cr-idsub', fmtDate(r.created) + (r.verified ? ' · VERIFIED CARGO' : '')));
      meta.appendChild(stars(r.rating));
      id.appendChild(meta);
      card.appendChild(id);
      if (r.title) card.appendChild(el('p', 'nbp-cr-ltitle', r.title));
      card.appendChild(el('p', 'nbp-cr-lbody', r.body));
      if (r.photos.length) {
        var g = el('div', 'nbp-cr-lpics');
        r.photos.forEach(function (p, i) {
          var b = el('button', 'nbp-cr-lpic');
          b.type = 'button';
          b.setAttribute('aria-label', 'Open photo ' + (i + 1));
          var im = el('img'); im.src = p.thumb; im.alt = ''; im.loading = 'lazy'; im.width = 100; im.height = 66;
          b.appendChild(im);
          b.addEventListener('click', function () { openLb(r.photos.map(function (q) { return q.full; }), i, b); });
          g.appendChild(b);
        });
        card.appendChild(g);
      }
      pop.classList.add('is-open');
      pop.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      x.focus();
    }

    var lb = el('div', 'nbp-lb nbp-cr-lb');
    lb.tabIndex = -1;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Field photos');
    var lbTop = el('div', 'nbp-lb-top');
    lbTop.appendChild(el('span', 'nbp-lb-label', '[ FIELD PHOTOS ]'));
    var lbCount = el('span', 'nbp-lb-count');
    lbTop.appendChild(lbCount);
    var lbX = el('button', 'nbp-lb-close', '✕');
    lbX.type = 'button'; lbX.setAttribute('aria-label', 'Close');
    lbTop.appendChild(lbX);
    lb.appendChild(lbTop);
    var bay = el('div', 'nbp-lb-bay');
    var lbImg = el('img', 'nbp-lb-img');
    lbImg.alt = 'Review photo';
    bay.appendChild(lbImg);
    var prev = el('button', 'nbp-lb-nav prev', '<<'); prev.type = 'button'; prev.setAttribute('aria-label', 'Previous photo');
    var next = el('button', 'nbp-lb-nav next', '>>'); next.type = 'button'; next.setAttribute('aria-label', 'Next photo');
    bay.appendChild(prev); bay.appendChild(next);
    lb.appendChild(bay);
    document.body.appendChild(lb);
    var lbList = [], lbI = 0, lbFrom = null, popWasOpen = false;
    function lbSet(i) {
      lbI = (i + lbList.length) % lbList.length;
      lbImg.src = lbList[lbI];
      lbCount.textContent = '// PHOTO ' + pad(lbI + 1, 2) + ' / ' + pad(lbList.length, 2);
      prev.hidden = next.hidden = lbList.length < 2;
    }
    function openLb(listUrls, i, from) {
      if (!listUrls.length) return;
      lbList = listUrls; lbFrom = from;
      popWasOpen = pop.classList.contains('is-open');
      lbSet(i);
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      lbX.focus();
    }
    function closeLb() {
      lb.classList.remove('is-open');
      if (!popWasOpen) document.documentElement.style.overflow = '';
      if (lbFrom && lbFrom.focus) lbFrom.focus();
    }
    lbX.addEventListener('click', closeLb);
    prev.addEventListener('click', function () { lbSet(lbI - 1); });
    next.addEventListener('click', function () { lbSet(lbI + 1); });
    lb.addEventListener('mousedown', function (e) { if (e.target === lb || e.target === bay) closeLb(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeLb(); return; }
      if (e.key === 'ArrowLeft') lbSet(lbI - 1);
      if (e.key === 'ArrowRight') lbSet(lbI + 1);
      trap(lb, e);
    });

    renderPhotos();
    render();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cr]');
    for (var i = 0; i < roots.length; i++) {
      var src = roots[i].parentNode.querySelector('script[data-cr-data]');
      if (!src) continue;                         // no data beside it → someone else mounts it (the fixture harness)
      var data = {};
      try { data = JSON.parse(src.textContent); } catch (e) { data = {}; }
      mount(roots[i], data);
    }
  }
  window.NimbusReviews = { mount: mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
